// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-item {
  padding: 1rem;
  background-color: white;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.dark .order-item {
  color: white;
  background-color: #353a50;
}

.divider {
  width: 100%;
  opacity: 0.3;
}

.order-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.order-item-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.order-item-body {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/OrderCard/OrderCard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB","sourcesContent":[".order-item {\n  padding: 1rem;\n  background-color: white;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n}\n\n.dark .order-item {\n  color: white;\n  background-color: #353a50;\n}\n\n.divider {\n  width: 100%;\n  opacity: 0.3;\n}\n\n.order-item-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.order-item-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.order-item-body {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
